import { createContext, useContext } from "react";
import { SituationModel, ScenarioModel } from "../../clients/KompasApi";

const ComparePageContext = createContext<{ situation: SituationModel; scenarios: ScenarioModel[] }>(undefined!);

export const ComparePageContextProvider = ComparePageContext.Provider;

export const useComparePageContext = () => {
  const context = useContext(ComparePageContext);
  if (!context) {
    throw new Error("useComparePageContext must be used within a ComparePageContextProvider");
  }
  return context;
}